export function isNonEmptyArray(value) {
    return value.length !== 0;
}
